import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex-grow px-4 py-2 md:px-12 md:py-4 w-full" }
const _hoisted_2 = { class: "leading-none mt-[5vw] mb-[1vw] flex justify-between max-w-[37.50rem]" }
const _hoisted_3 = {
  id: "main-content",
  class: "text-muted text-lg max-w-[37.50rem]"
}
const _hoisted_4 = { class: "fixed inset-0 pointer-events-none overflow-hidden" }
const _hoisted_5 = { class: "grid grid-cols-4 gap-3 mb-4 touch-manipulation" }
const _hoisted_6 = ["disabled", "aria-label", "onClick", "onDblclick"]
const _hoisted_7 = { class: "flex flex-col items-center justify-center h-full touch-manipulation" }
const _hoisted_8 = ["disabled"]

import { ref, onBeforeUnmount } from 'vue'
import PartySocket from 'partysocket'


export default /*@__PURE__*/_defineComponent({
  __name: 'live',
  setup(__props) {

const predefinedEmojis = ['👍', '❤️', '😂', '👏', '🔥', '🎉', '🤯', '👨‍💻', '🙌', '🎯', '✅']
const customEmoji = ref('')
const displayedReactions = ref<Array<{
  id: string
  emoji: string
  position: { x: number, y: number }
  size: number
}>>([])
const isConnected = ref(false)

// Connect to PartyKit
let partySocket: PartySocket
if (import.meta.client) {
  onNuxtReady(() => {
    partySocket = new PartySocket({
      host: import.meta.dev ? 'localhost:1999' : 'v.danielroe.partykit.dev',
      room: 'reactions',
    })

    partySocket.onopen = () => {
      isConnected.value = true
    }
  })

  onBeforeUnmount(() => partySocket?.close())
  onDeactivated(() => partySocket?.close())
  onActivated(() => partySocket?.reconnect())
}

async function sendEmoji (emoji: string, count = 1) {
  if (!isConnected.value) return
  for (let i = 0; i < count; i++) {
    partySocket.send(`reaction:${emoji}`)
    displayReaction(emoji)
    await new Promise(resolve => setTimeout(resolve, 100))
  }
}

watch(customEmoji, sendCustomEmoji)

function sendCustomEmoji (emoji: string) {
  if (!emoji?.trim() || !isConnected.value) return

  // Basic client-side emoji validation
  if (!isValidEmoji(emoji)) {
    customEmoji.value = ''
    return
  }

  sendEmoji(emoji)
  customEmoji.value = ''
}

function displayReaction (emoji: string) {
  const id = Date.now().toString() + Math.random().toString()
  const size = Math.random() * 20 + 30 // 30-50px size

  // Create the reaction with position information only
  const newReaction = {
    id,
    emoji,
    position: {
      x: Math.random() * 80 + 10, // 10-90% horizontal
      y: 5, // Start near bottom (5% from bottom)
    },
    size,
  }

  displayedReactions.value.push(newReaction)

  // Remove the reaction after animation completes (matches the CSS animation duration)
  setTimeout(() => {
    displayedReactions.value = displayedReactions.value.filter(r => r.id !== id)
  }, 2500) // 2.5s = animation duration
}

function preventZoom () {
  // This helps prevent double-tap zoom on iOS/mobile
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "text-2xl" }, " what are you thinking? ", -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["mt-4 text-sm", isConnected.value ? 'text-green-500' : 'text-red-500'])
      }, _toDisplayString(isConnected.value ? 'connected' : 'connecting...'), 3)
    ]),
    _createElementVNode("main", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_TransitionGroup, { name: "fade" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedReactions.value, (reaction) => {
              return (_openBlock(), _createElementBlock("div", {
                key: reaction.id,
                class: "emoji-reaction absolute pointer-events-none select-none z-999",
                style: _normalizeStyle({
              left: `${reaction.position.x}%`,
              bottom: `${reaction.position.y}%`,
              fontSize: `${reaction.size}px`,
            })
              }, _toDisplayString(reaction.emoji), 5))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(predefinedEmojis, (emoji) => {
          return _createElementVNode("button", {
            key: emoji,
            type: "button",
            class: "aspect-square text-[1.75rem] rounded-lg flex items-center justify-center bg-muted bg-opacity-10 transition-all duration-200 hover:bg-opacity-20 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed select-none f-ring",
            disabled: !isConnected.value,
            "aria-label": `Send ${emoji} reaction`,
            onClick: ($event: any) => (sendEmoji(emoji)),
            onDblclick: ($event: any) => (sendEmoji(emoji, 3)),
            onTouchstartPassive: preventZoom
          }, _toDisplayString(emoji), 41, _hoisted_6)
        }), 64)),
        _createElementVNode("form", {
          class: _normalizeClass(["aspect-square rounded-lg bg-muted/15 transition-all duration-200 hover:bg-muted/25", { 'opacity-50 cursor-not-allowed': !isConnected.value }]),
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => sendCustomEmoji(customEmoji.value), ["prevent"]))
        }, [
          _createElementVNode("label", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customEmoji).value = $event)),
              type: "text",
              class: "w-14 h-14 text-center text-[1.75rem] bg-transparent border-none rounded-lg f-ring-inset",
              disabled: !isConnected.value,
              "aria-label": "Custom emoji input",
              onTouchstartPassive: preventZoom
            }, null, 40, _hoisted_8), [
              [_vModelText, customEmoji.value]
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-xs text-muted mt-1" }, "custom", -1))
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("button", {
            type: "submit",
            class: "sr-only"
          }, " Submit ", -1))
        ], 34)
      ])
    ])
  ]))
}
}

})